import { ARCHIVE_RECORD_STEPS } from './archiveRecordForm'

export type ArchiveStepItem = { id: number; label: string }

type ArchiveStepperProps = {
  currentStep: number
  steps?: readonly ArchiveStepItem[]
}

const ArchiveStepper = ({ currentStep, steps = ARCHIVE_RECORD_STEPS }: ArchiveStepperProps) => (
  <div className="border-b border-[#E5E7EB] px-8 pb-4 pt-2">
    <div className="flex items-center justify-between gap-2">
      {steps.map(step => {
        const isActive = currentStep === step.id
        const isComplete = currentStep > step.id
        return (
          <div className="flex min-w-0 flex-1 flex-col items-center gap-2" key={step.id}>
            <span
              className={`text-center text-xs font-medium sm:text-sm ${
                isActive ? 'text-[#111827]' : isComplete ? 'text-[#374151]' : 'text-[#9CA3AF]'
              }`}
            >
              {step.id}. {step.label}
            </span>
            <span
              className={`h-0.5 w-full rounded-full ${isActive ? 'bg-[#099C32]' : isComplete ? 'bg-[#D1D5DB]' : 'bg-transparent'}`}
            />
          </div>
        )
      })}
    </div>
  </div>
)

export default ArchiveStepper
